import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Document"
}
const _hoisted_2 = { class: "Document__paper" }
const _hoisted_3 = { class: "Document__side" }
const _hoisted_4 = {
  key: 0,
  class: "Document__status"
}

import { onMounted, ref, watch, computed } from "vue";
import { Document } from "@/types";
import { useRoute, useRouter } from "vue-router";
import { useDocumentsStore } from "@/stores/documents";
import { documentToSlug } from "@/tools/document";
import Paper from "@/components/pages/document/Paper.vue";
import DocumentTools from "@/components/pages/document/tools/DocumentTools.vue";
import { useDebounceFn } from "@vueuse/core";
import api from "@/api";
import { useUiStore } from "@/stores/ui";
import PaidStatus from "@/components/pages/documents/card/PaidStatus.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const uiStore = useUiStore();
const documentsStore = useDocumentsStore();
const document = ref<Document | null>(null);
const watchActive = ref(false);

const debouncedFn = useDebounceFn(() => {
    if (document.value) {
        api.update(document.value, "documents").then(() => {
            uiStore.message("Wijzigingen opgeslagen...");
        });
    }
}, 1000);

const owner = computed(() => {
    return document.value?.user_id === uiStore.user?.id;
});

watch(
    () => document.value,
    () => {
        if (watchActive.value) {
            debouncedFn();
        }
    },
    { deep: true }
);

onMounted(() => {
    const slug = String(route.params.slug);
    const prefix = String(route.params.prefix);
    const d = documentsStore.list.find(
        (document: Document) =>
            documentToSlug(document) === slug && document.doctype === prefix
    );
    if (d) {
        document.value = d;
        setTimeout(() => {
            watchActive.value = true;
        });
    } else {
        router.push({ name: "Documents" });
    }
});

return (_ctx: any,_cache: any) => {
  return (document.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Paper, {
            document: document.value,
            editable: owner.value && !document.value.locked
          }, null, 8, ["document", "editable"]),
          _createElementVNode("div", _hoisted_3, [
            (!document.value.locked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Concept "))
              : (_openBlock(), _createBlock(PaidStatus, {
                  key: 1,
                  document: document.value
                }, null, 8, ["document"]))
          ])
        ]),
        _createVNode(DocumentTools, {
          document: document.value,
          owner: owner.value
        }, null, 8, ["document", "owner"])
      ]))
    : _createCommentVNode("", true)
}
}

})